import React, { useState, useEffect, useRef } from 'react';
import cx from 'classnames';
import './SearchSelect.css';

import { useTranslation } from 'utils/modifiedTranslation';
import PropTypes from 'prop-types';
import searchIcon from 'assets/icons/status_2.svg';
import Button from 'new-ui/Components/Button';

import Tags from 'new-ui/Components/Tags';
import { QuestionTitle } from '../../QuestionTitle';
import MultipleOptionSelect from '../MultipleOptionSelect';

export const SearchSelect = (props) => {
  const { t } = useTranslation();
  const {
    q,
    onselect = () => {},
    initValue = [],
    buttonText = t('general.save'),
    showTitle = false,
    infoNote,
    onChange,
  } = props;
  const controller = {};
  const [search, setSearch] = useState('');
  const [selectedOptionValues, setSelectedOptionValues] = useState(Array.isArray(initValue) ? initValue : []);
  const $input = useRef(null);

  useEffect(() => {
    if (controller?.setValue) {
      controller.setValue(selectedOptionValues);
    }
    // eslint-disable-next-line
  }, [selectedOptionValues]);

  useEffect(() => {
    if (onChange) {
      onChange(selectedOptionValues);
    }
  }, [onChange, selectedOptionValues]);

  const allOptions = (q.options ?? []).map((a) => ({
    label: t(a.label),
    value: a.value,
  }));

  const renderResults = () => {
    const options = allOptions.filter((a) => a.label.toLowerCase().indexOf(search.toLowerCase()) !== -1);
    return (
      <MultipleOptionSelect
        q={{
          options,
        }}
        autoChange
        initValue={selectedOptionValues}
        controller={controller}
        onselect={(v) => {
          setSelectedOptionValues(v);
          setSearch('');
          $input.current.value = '';
          $input.current.focus();
          onselect(v, true);
        }}
      />
    );
  };

  const tagsItems = selectedOptionValues.map((selected) => ({
    title: allOptions.find((a) => a.value === selected)?.label,
    value: selected,
    action: (value) => {
      const v = [...selectedOptionValues];
      v.splice(v.indexOf(value), 1);
      setSelectedOptionValues(v);
    },
  }));

  return (
    <div className="search-select">
      {showTitle ? <QuestionTitle q={q} /> : null}
      <div className={cx('search-select-input', { 'search-select-input-value': search })}>
        <input
          ref={$input}
          placeholder="Start typing name..."
          onChange={(ev) => {
            setSearch(ev.currentTarget.value);
          }}
        />
        <img alt="icon" src={searchIcon} />
      </div>
      {selectedOptionValues?.length ? (
        <div className="search-select-selecteds">
          <Tags items={tagsItems} />
        </div>
      ) : null}
      {search ? (
        <div className="search-results">
          {renderResults()}
        </div>
      ) : null}
      {infoNote}
      {selectedOptionValues.length ? (
        <Button
          title={buttonText}
          action={() => {
            onselect(selectedOptionValues);
          }}
        />
      ) : null}
    </div>
  );
};

SearchSelect.propTypes = {
  q: PropTypes.object.isRequired,
  onselect: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  initValue: PropTypes.any,
  buttonText: PropTypes.string,
  showTitle: PropTypes.bool,
  infoNote: PropTypes.node,
};
